import { useContext } from 'react';
import { DateTime } from 'luxon';

import { cartContext } from 'contexts/cartContext';
import useEnv from './useEnv';
import { apiUrls } from 'services/api-urls';
import { Cart } from 'types/Cart';
import { ShippingFormType } from 'types/ShippingFormType';

const useCart = (): {
  cart: Cart | undefined;
  updateShippingMethod: (
    params: Partial<ShippingFormType>,
    additionalOptions?: RequestInit
  ) => Promise<Cart | undefined>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateCart: (Date) => Promise<any>;
} => {
  const { urlApiCustomer } = useEnv();
  const { cart, mutateCart } = useContext(cartContext);

  return {
    // context
    cart,

    // API
    updateShippingMethod: async (
      params: Partial<ShippingFormType>,
      additionalOptions?: RequestInit
    ): Promise<Cart | undefined> => {
      const response = await fetch(apiUrls.getCheckoutDeliveryUpdate(), {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-AUTH-TOKEN': process.env.REACT_APP_API_SYMFONY_API_KEY as string,
        },
        body: JSON.stringify({
          typeAddress: params?.addressType,
          delivery: params?.shippingMethod,
          relayPoint: params?.relayPoint,
          mondialRelayPoint: params?.mondialRelayPoint,
        }),
        ...(additionalOptions || {}),
      });

      if (!response.ok) {
        const { message } = await response.json();
        console.error(message);

        return Promise.reject(new Error(message));
      }

      const updatedCart: Cart = await response.json();

      mutateCart(updatedCart);

      return Promise.resolve(updatedCart);
    },
    updateCart: async (dateOfBirth: Date) => {
      if (
        dateOfBirth &&
        dateOfBirth instanceof Date &&
        !isNaN((dateOfBirth as unknown) as number)
      ) {
        await fetch(`${urlApiCustomer}/update`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'X-AUTH-TOKEN': `${process.env.REACT_APP_API_SYMFONY_API_KEY}`,
          },
          body: JSON.stringify({
            dateOfBirth: DateTime.fromJSDate(dateOfBirth).toFormat('d/M/yyyy'),
          }),
        });
      }
    },
  };
};

export default useCart;
